<template>
  <div class="container-fluid">
    <footer class="footer bg-light text-center text-md-left my-footer">
      <div class="container-fluid" style="background-color: rgba(0, 77, 238) !important; margin: 0">
        <div class="row justify-content-around .no-gutters dibudiv">


          <!-- 第一部分：菜单（左上角，蓝色加粗） -->
          <div class="col-auto mb-sm-2"> <!-- 或者 col-2，根据需要调整 -->
            <div class="row mb-1 align-items-center justify-content-md-start justify-content-sm-around  menu-row-class">
              <img src="@/assets/images/footer/menu.png" class="menu-class mr-1" >
              <h5 class="email-class-title" style="color:  #FFFFFF;">{{ $t(`h.menu`) }}</h5>
            </div>
            <ul class="list-unstyled align-items-center justify-content-md-start justify-content-sm-around link-class">
                <li class="nav-item" v-for="item in navItems" :key="item.path">
              <router-link style="color: #FFFFFF !important;" :to="item.path"
                           :class="{'nav-link active nav-active': $route.path === item.path, 'nav-link': true}">
                {{ $t(item.messageKey) }}
              </router-link>
            </li>
            </ul>
          </div>


          <!-- 第三部分：介绍信息 -->
          <div class="col-md-4 col-auto justify-content-center link-class  zhongjian" >
            <div class="row mb-2 align-items-center justify-content-md-start justify-content-center menu-row-class">
              <img src="@/assets/images/footer/email.png" class="email-class mr-1" >
              <h5 class="email-class-title" style="color:  #FFFFFF">{{ $t("h.contact_us") }}</h5>
            </div>
            <div class="row align-items-center justify-content-md-start justify-content-sm-around">
              <p style="color:  #FFFFFF; width: 250px;"  >
                {{ formattedText($t("h.coo_address")) }}
              </p>
            </div>
            <div class="row   align-items-center justify-content-md-start justify-content-center">
              <p style="color:  #FFFFFF" >{{ $t("h.footer_email") }}</p>
            </div>
            <div class="row  align-items-center justify-content-md-start justify-content-center">
              <p style="color:  #FFFFFF" >{{ $t("h.footer_phone") }}</p>
            </div>
          </div>

          <!-- 第四部分：电话列表 -->
          <div class="col-md-auto col-auto mt-3 mt-md-0 justify-content-center link-class">
            <div
                class="row mb-1 align-items-center align-items-center justify-content-md-start justify-content-sm-around menu-row-class">
              <img src="@/assets/images/footer/follow.png" class="follow-class mr-1" style="margin-bottom: 1vw;">
              <h5 class="email-class-title" style="color: white;">{{ $t("h.follow_us") }}</h5>
            </div>
            <ul class="list-unstyled justify-content-center">
              <li v-for="(concat, index) in contact" :key="index" style=" margin-top: 10px;" class="mb-2 row align-items-center">
                <a style="color:white !important;" :href="concat.number" class="text-dark align-items-center">
                  <img class="img-thumbnail circle-class"
                       :src="require(`../../public/images/home/phone/${concat.name}.png`)"><span>  {{ concat.number }}</span>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {contact} from "@/constant/concats";

export default {
  name: 'MyFooter',
  data() {
    return {
      // 在这里定义你的数据
      navItems: this.$router.options.routes.map(route => ({
        path: route.path,
        messageKey: route.meta.messageKey
      })),
      contact: contact
    }
  },methods: {
    formattedText(key) {
      const text = this.$t(key);
      // Adding spaces around colons
      return text.replace(/:(?!\s)/g, ': ');
    },
  }
}
</script>

<style scoped>
.email-class-title {
  font-size: 25px;
}

.dibudiv {
  padding: 1% !important;
}

.my-footer {
  margin-top: auto;
}

.container-fluid {
  padding: 0;
}

.menu-class, .email-class, .follow-class {
  /* Common styles for image icons */
  object-fit: cover;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Shadow effect */
}

.menu-class {
  width: 1.7vw;
  height: 1.7vw;
  margin-bottom: 1vw;
}

.email-class {
  width: 1.7vw;
  height: 1.4vw;
  margin-bottom: 1vw;
}

.follow-class {
  width: 1.4vw;
  height: 1.8vw;
  margin-bottom: 1vw;
}

.menu-row-class {
  padding-left: 0vw;
}

.link-class {
  font-size: 12px;
}

.circle-class {
  border-radius: 100%;
  width: 1.5vw;
  height: 1.5vw;
}

.email-class-title {
  margin-bottom: 10px;
}

@media (max-width: 567px) {
  /* Adjust image sizes for smaller screens */
  .menu-class {
    width: 4vw;
    height: 4vw;
    margin-right: 2vw;
  }

  .email-class {
    width: 5vw;
    height: 4vw;
    margin-right: 2vw;
  }

  .follow-class {
    width: 4vw;
    height: 5.5vw;
    margin-right: 2vw;
  }

  .circle-class {
    width: 5vw;
    height: 5vw;
  }

  .container-fluid {
    padding: 0 1vw;
  }

  .my-footer {
    padding: 1vw;
  }

  .row {
    flex-direction: column;
    align-items: center; /* Center items in columns */
  }

  .col-auto {
    width: 100%; /* Make columns full width */
    text-align: center; /* Center text in columns */
    margin-bottom: 2vw; /* Space between rows */
  }

  .email-class-title {
    font-size: 20px;
  }

  .link-class {
    font-size: 10px;
  }
  
}


/* 如果需要更精确地控制每个断点，可以添加更多的媒体查询 */
/* 例如，对于大屏幕（lg及以上） */
@media (min-width: 992px) {
.zhongjian{
  margin-left: 18%;
 }
}

/* 对于超大屏幕（xl） */
@media (min-width: 1200px) {
  /* 如果需要的话，可以添加特定样式 */
 .zhongjian{
   margin-left: 18%;
 }
}

</style>
